import React, { useState } from "react";
import { BsTable } from "react-icons/bs";
// import { FaLandmark } from "react-icons/fa";
import $ from "jquery";

export default function Summary({ buyingList, wallet, total }) {
  const [higherProfits, sethigherProfits] = useState();
  const [higherLosses, sethigherLosses] = useState();
  const calcProfitsNumber = () => {
    const totalProfitsLength = [];
    const totalLossesLength = [];
    const total = buyingList.filter((element) => element.completed);
    total.forEach((element) => {
      if (element.totalProfits >= 0) totalProfitsLength.push(element);
      if (element.totalProfits <= 0) totalLossesLength.push(element);
    });
    document.getElementById("totalProfitsLength").innerHTML =
      totalProfitsLength.length;
    document.getElementById("totalLossesLength").innerHTML =
      totalLossesLength.length;
    const topProfits = totalProfitsLength
      .sort((a, b) => (b.percentage > a.percentage ? 1 : -1))
      .slice(0, 5);
    sethigherProfits(topProfits);
    const topLosses = totalLossesLength
      .sort((a, b) => (a.percentage > b.percentage ? 1 : -1))
      .slice(0, 5);
    sethigherLosses(topLosses);
  };
  return (
    <div>
      <span
        data-toggle="modal"
        data-target="#summary"
        className="position-relative"
      >
        <button
          className="btn btn-sm btn-outline-light"
          data-toggle="tooltip"
          data-placement="bottom"
          title="ملخص الحساب"
          onClick={() => {
            calcProfitsNumber();
            $("button").tooltip("hide");
          }}
        >
          <BsTable size="1.2em" />
        </button>
      </span>
      <div
        className="modal fade"
        id="summary"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                ملخص الحساب
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body p-0 m-2">
              <div className="container-fluid">
                <div className="row">
                  <div className="card bg-light text-dark col-lg p-0">
                    <h5 className="card-header ">الحساب</h5>
                    <div className="d-flex w-100">
                      <p
                        className="border-left p-2 mb-0"
                        style={{ width: "50%" }}
                      >
                        رصيد المحفظة
                      </p>
                      <p
                        className="mb-0 p-2 text-center"
                        style={{ width: "50%" }}
                      >
                        {wallet}
                      </p>
                    </div>
                    <hr className="m-0" />
                    <div className="d-flex ">
                      <p
                        className="border-left p-2 mb-0"
                        style={{ width: "50%" }}
                      >
                        اجمالي الارباح/الخسائر
                      </p>
                      <p
                        className={
                          "mb-0 p-2 text-center " +
                          (total < 0 ? "text-danger" : "text-success")
                        }
                        style={{ width: "50%" }}
                      >
                        {" "}
                        {total.toFixed(2)}
                      </p>
                    </div>
                    <hr className="m-0" />
                    <div className="d-flex">
                      <p
                        className="border-left p-2 mb-0"
                        style={{ width: "50%" }}
                      >
                        اجمالي الرصيد
                      </p>
                      <p
                        className={
                          "mb-0 p-2 text-center " +
                          (+total + +wallet < wallet
                            ? "text-danger"
                            : "text-success")
                        }
                        style={{ width: "50%" }}
                      >
                        {(+total + +wallet).toFixed(2)}
                      </p>
                    </div>
                    <hr className="m-0" />
                    <div className="d-flex">
                      <p
                        className="border-left p-2 mb-0"
                        style={{ width: "50%" }}
                      >
                        عدد الصفقات الرابحة
                      </p>
                      <p
                        className="p-2 text-success mb-0 text-center"
                        style={{ width: "50%" }}
                        id="totalProfitsLength"
                      >
                        0
                      </p>
                    </div>
                    <hr className="m-0" />
                    <div className="d-flex">
                      <p
                        className="border-left p-2 mb-0"
                        style={{ width: "50%" }}
                      >
                        عدد الصفقات الخاسرة
                      </p>
                      <p
                        className="p-2 text-danger mb-0 text-center"
                        style={{ width: "50%" }}
                        id="totalLossesLength"
                      >
                        0
                      </p>
                    </div>
                  </div>
                  <div className="card bg-light text-dark col-lg-12 p-0 mt-2">
                    <h5 className="card-header ">اعلى الصفقات الرابحة</h5>
                    <div className="d-flex">
                      <h6
                        className="mb-0 p-2 d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        الشركة
                      </h6>
                      <h6
                        className="mb-0 p-2 d-flex align-items-center justify-content-center text-center"
                        style={{ width: "25%" }}
                      >
                        نسبة الربح
                      </h6>
                      <h6
                        className="mb-0 p-2 d-flex align-items-center justify-content-center text-center"
                        style={{ width: "25%" }}
                      >
                        مبلغ الربح
                      </h6>
                    </div>
                    <hr className="m-0" />
                    <>
                      {higherProfits &&
                        higherProfits.map((list) => {
                          return (
                            <div key={list.id}>
                              <div className="d-flex">
                                <p
                                  className="mb-0 p-2"
                                  style={{ width: "50%" }}
                                >
                                  {list.company}
                                </p>
                                <p
                                  className="mb-0 p-2 text-success text-center"
                                  style={{ width: "25%" }}
                                >
                                  {list.percentage.toFixed(2)}&rlm;{"%"}
                                </p>
                                <p
                                  className="mb-0 p-2 text-success text-center"
                                  style={{ width: "25%" }}
                                >
                                  {list.totalProfits.toFixed(2)}
                                </p>
                              </div>
                              <hr className="m-0" />
                            </div>
                          );
                        })}
                    </>
                  </div>
                  <div className="card bg-light text-dark col-lg p-0 mt-2">
                    <h5 className="card-header ">اعلى الصفقات الخاسرة</h5>
                    <div className="d-flex">
                      <h6
                        className="mb-0 p-2 d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        الشركة
                      </h6>
                      <h6
                        className="mb-0 p-2 d-flex align-items-center justify-content-center text-center"
                        style={{ width: "25%" }}
                      >
                        نسبة الخسارة
                      </h6>
                      <h6
                        className="mb-0 p-2 d-flex align-items-center justify-content-center text-center"
                        style={{ width: "25%" }}
                      >
                        مبلغ الخسارة
                      </h6>
                    </div>
                    <hr className="m-0" />
                    <>
                      {higherLosses &&
                        higherLosses.map((list) => {
                          return (
                            <div key={list.id}>
                              <div className="d-flex justify-content-between">
                                <p
                                  className="mb-0 p-2"
                                  style={{ width: "50%" }}
                                >
                                  {list.company}
                                </p>
                                <p
                                  className="mb-0 p-2 text-danger text-center"
                                  style={{ width: "25%" }}
                                >
                                  {list.percentage.toFixed(2)}&rlm;{"%"}
                                </p>
                                <p
                                  className="mb-0 p-2 text-danger text-center"
                                  style={{ width: "25%" }}
                                >
                                  {list.totalProfits.toFixed(2)}
                                </p>
                              </div>
                              <hr className="m-0" />
                            </div>
                          );
                        })}
                    </>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
